<template>
  <div class="popup-wrapper" v-if="visible">
    <div class="popup">
      <img src="@/assets/imgs/common/close.png" alt="닫기" class="close" @click="clickCloseModal" />
      <p class="title-text">개인정보 수집 및 이용</p>
      <div class="name-wrapper">
        <p class="agree-desc">
          1. 개인정보의 수집 및 이용 목적 <br />
          캐럿글로벌은 수집한 개인정보를 다음의 목적을 위해 활용합니다. <br />
          ο 문의접수와 처리, 회신 <br />
          <br />
          2. 수집하는 개인정보의 항목 캐럿글로벌은 문의접수와 처리, 회신을 위해 아래와 같은 개인정보를 수집하고 있습니다. <br />
          가. 수집하는 개인정보 항목 <br />
          ο 이름, E-mail, 연락처<br />
          나. 수집방법 <br />
          1) 홈페이지를 통한 1:1 문의<br />
          2) 이용자 쿠키정보 활용<br /><br />

          3. 수집한 개인정보의 보유 및 이용기간 개인정보의 보유 및 이용기간은 다음과 같습니다.<br />
          ο 보유항목: 수집항목과 같습니다. <br />
          ο 보유근거: 이용약관 및 개인정보취급방침 <br />
          ο 보유기간: 문의접수 후 1년간 보관 <br /><br />

          4. 귀하는 위와 같은 개인정보 수집 및 이용에 동의하지 않을 수 있으며, <br />
          동의하지 않을 시 문의하기 서비스가 제한될 수 있습니다.<br />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["closeModal"],
  setup(_, cotext) {
    const clickCloseModal = () => {
      cotext.emit("closeModal");
    };

    return {
      clickCloseModal,
    };
  },
};
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .popup {
    display: flex;
    flex-direction: column;
    background-color: $white;
    border-radius: 14px;
    padding: 20px 42px 47px 42px;
    width: 500px;
    max-width: 500px;

    .inquriry {
      color: #949494;
      padding: 15px;
      background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
      border: none;

      &:focus {
        border: none;
      }
    }

    .agree-text {
      text-decoration: underline;
    }

    .submit {
      font-weight: $bold;
      color: $white;
      text-align: center;
      background-color: $blue;
      padding: 10px;
      border-radius: 8px;
      cursor: pointer;
      border: none;
    }

    .title-text {
      font-size: 30px;
      font-weight: $bold;
      text-align: center;
      margin-bottom: 40px;
    }

    .close {
      width: 19px;
      align-self: flex-end;
      margin-bottom: 25px;
      cursor: pointer;
    }

    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px rgba($color: $gray-dde0e4, $alpha: 0.5) inset;
    }

    .name-wrapper {
      display: flex;
      flex-direction: column;
      gap: 9px 0;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid rgba($color: $black, $alpha: 0.07);

      .agree-desc {
        height: 300px;
        background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
        color: #949494;
        overflow-y: scroll;
        padding: 15px;
        font-size: 13px;
      }

      label {
        font-weight: $bold;
      }

      input {
        font-size: 16px;
        color: $black;
        padding: 15px;
        background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
        border-radius: 8px;

        &::placeholder {
          color: #949494;
        }
      }
    }

    .select-wrapper {
      .tab-title {
        display: flex;
        justify-content: space-between;
        gap: 0 12px;
        margin-bottom: 17px;

        li {
          width: 50%;
          font-size: 14px;
          font-weight: $bold;
          color: #959595;
          text-align: center;
          border: 1px solid #959595;
          border-radius: 8px;
          padding: 13px 0;
          cursor: pointer;

          &.on {
            color: $blue;
            border: 1px solid $blue;
          }
        }
      }

      .tab-sub {
        margin-bottom: 37px;

        .radio-wrapper {
          display: flex;
          gap: 0 17px;
          margin-bottom: 7px;

          li {
            display: flex;
            align-items: center;
            gap: 0 5px;

            input {
              width: 12px;
              height: 12px;
            }

            label {
              font-size: 14px;
              font-weight: $bold;
            }
          }
        }

        .input-wrapper {
          li {
            display: flex;

            input {
              flex-grow: 1;
              font-size: 16px;
              color: #949494;
              padding: 15px;
              background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
              border-radius: 8px;
            }

            .country-box {
              flex-grow: 1;
              font-size: 16px;
              color: $black;
              padding: 15px;
              background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
              border-radius: 8px;
              display: flex;
              cursor: pointer;
            }

            .item1 {
              width: 10%;
            }

            .item2 {
              width: 80%;
            }

            .item3 {
              width: 10%;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .arrow-img {
              width: 12px;
              height: 9px;
              cursor: pointer;
            }
          }

          .select-country-wrapper {
            gap: 0 12px;
            margin-bottom: 8px;
            position: relative;
            // height: 48px;

            .country-list {
              position: absolute;
              overflow-y: scroll;
              top: 58px;
              left: 0;
              width: 100%;
              transform: scaleY(0);
              background-color: $white;
              border: solid 1px #e7e7e7;
              border-radius: 8px;

              box-shadow: 3.6px 1.8px 40px 0 rgba(0, 0, 0, 0.13);

              &.active {
                transform: scaleY(1);
              }
            }

            .country-list::-webkit-scrollbar {
              width: 3px;
            }

            .country-list::-webkit-scrollbar-thumb {
              background-color: $black;
            }
            .country-list::-webkit-scrollbar-track {
              background-color: $gray-cdcdcd;
            }

            .country-wrap {
              display: flex;
              padding: 10px 10px 0 10px;
            }

            .country-item:hover {
              background-color: $gray-f6f7f8;
            }

            .country-flag {
              width: 10%;
              border-bottom: 1px solid #e7e7e7;
              padding-bottom: 10px;
            }

            .country-text {
              width: 90%;
              border-bottom: 1px solid #e7e7e7;
              padding-bottom: 10px;
            }
          }

          .get-code-wrapper {
            justify-content: space-between;
            gap: 0 12px;
            margin-bottom: 8px;

            p {
              font-size: 14px;
              color: $white;
              text-align: center;
              line-height: 48px;
              padding: 0 17px;
              background-color: $black;
              border-radius: 8px;
              flex: none;
              cursor: pointer;
            }
          }

          .write-code-wrapper {
            flex-direction: column;

            .warning {
              font-size: 14px;
              color: $red;
              margin-top: 10px;
            }
          }
        }
      }

      .ok {
        max-width: 162px;
        margin: 0 auto;
        font-weight: $bold;
        color: $white;
        text-align: center;
        background-color: $blue;
        padding: 16px 0;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>
